import styled from "styled-components";

export const StyledCashierModal = styled.div`
  width: auto;
  min-width: 0;
  max-width: 100%;
  padding: 0;
  color: #eaf1f7;
  background: #142430;

  .cashier-home,
  .cashier-detail,
  .wallet-summary-card,
  .wallet-money-tabs,
  .wallet-info-grid,
  .wallet-guide,
  .wallet-form,
  .wallet-field,
  .wallet-input-shell,
  .wallet-quick-amounts,
  .wallet-inline-actions,
  .wallet-usdt-lite,
  .wallet-usdt-rate,
  .wallet-usdt-panel,
  .wallet-usdt-panel-head,
  .wallet-usdt-address,
  .wallet-copyline,
  .wallet-history,
  .wallet-history-table,
  .wallet-history-row {
    min-width: 0;
    max-width: 100%;
  }

  .cashier-modal-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 18px;
    padding: 24px 28px;
    background: rgba(8, 18, 26, 0.5);
    border-bottom: 1px solid rgba(132, 183, 208, 0.12);
  }

  .cashier-modal-title {
    display: inline-flex;
    align-items: center;
    gap: 12px;
    color: #ffffff;
    font-size: 28px;
    font-weight: 800;
    letter-spacing: 0;

    svg {
      color: #a8c4d5;
      flex: 0 0 auto;
    }
  }

  .cashier-modal-close {
    width: 44px;
    height: 44px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border: 0;
    border-radius: 12px;
    color: #a8c4d5;
    background: rgba(203, 215, 255, 0.06);
    cursor: pointer;
    transition: color 160ms ease, background 160ms ease, transform 160ms ease;

    &:hover {
      color: #ffffff;
      background: rgba(89, 244, 119, 0.12);
      transform: translateY(-1px);
    }
  }

  .cashier-modal-body {
    padding: 24px 28px 30px;
  }

  .cashier-modal-body.is-home .cashier-home {
    animation: cashierHomeEnter 220ms cubic-bezier(0.22, 1, 0.36, 1) both;
  }

  .cashier-modal-body.is-detail .cashier-detail {
    animation: cashierDetailEnter 220ms cubic-bezier(0.22, 1, 0.36, 1) both;
  }

  .cashier-action-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 14px;
    margin-top: 0;
  }

  .cashier-action-card {
    display: grid;
    grid-template-columns: auto minmax(0, 1fr);
    align-items: center;
    gap: 14px;
    min-height: 118px;
    padding: 18px;
    text-align: left;
    border: 1px solid rgba(132, 183, 208, 0.18);
    border-radius: 16px;
    color: #ffffff;
    background: rgba(8, 17, 27, 0.6);
    cursor: pointer;
    transition: transform 180ms ease, border-color 180ms ease, background 180ms ease, box-shadow 180ms ease;
  }

  .cashier-action-card,
  .cashier-action-balance,
  .cashier-action-balance b {
    min-width: 0;
    max-width: 100%;
  }

  .cashier-action-balance b {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .cashier-action-card:hover {
    transform: translateY(-3px);
    border-color: rgba(89, 244, 119, 0.56);
    background: rgba(11, 27, 34, 0.86);
    box-shadow: 0 16px 34px rgba(0, 0, 0, 0.24), 0 0 0 1px rgba(89, 244, 119, 0.08);
  }

  .cashier-action-icon {
    width: 48px;
    height: 48px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 14px;
    color: var(--crypto-green);
    background: rgba(89, 244, 119, 0.11);
    box-shadow: inset 0 0 0 1px rgba(89, 244, 119, 0.2);
    font-size: 18px;
    font-weight: 900;
  }

  .cashier-action-icon svg {
    width: 27px;
    height: 27px;
    display: block;
  }

  .cashier-action-copy {
    display: flex;
    min-width: 0;
    flex-direction: column;
    gap: 5px;
  }

  .cashier-action-copy strong {
    font-size: 18px;
    line-height: 1.2;
    letter-spacing: 0;
  }

  .cashier-action-copy small {
    color: #94a4b5;
    font-size: 13px;
    line-height: 1.35;
    font-weight: 600;
  }

  .cashier-action-balance {
    grid-column: 1 / -1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding-top: 12px;
    border-top: 1px solid rgba(132, 183, 208, 0.12);
  }

  .cashier-action-balance em {
    color: #7f91a3;
    font-size: 12px;
    font-style: normal;
    font-weight: 700;
  }

  .cashier-action-balance b {
    color: #f5f8fb;
    font-size: 14px;
    font-weight: 800;
  }

  .cashier-detail {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .wallet-back-button {
    align-self: flex-start;
    display: inline-flex;
    align-items: center;
    gap: 10px;
    padding: 0;
    border: 0;
    color: #ffffff;
    background: transparent;
    font-size: 24px;
    font-weight: 800;
    cursor: pointer;
  }

  .wallet-back-button span {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    color: #b2c6d5;
    font-size: 34px;
    line-height: 1;
    transform: translateY(-1px);
  }

  .wallet-summary-card {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 18px;
    padding: 18px 20px;
    border-radius: 16px;
    border: 1px solid rgba(132, 183, 208, 0.16);
    background:
      radial-gradient(circle at 96% 10%, rgba(89, 244, 119, 0.18), transparent 34%),
      rgba(8, 17, 27, 0.6);
  }

  .wallet-summary-card div {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .wallet-summary-card span {
    color: #8da0b2;
    font-size: 12px;
    font-weight: 700;
  }

  .wallet-summary-card strong {
    min-width: 0;
    max-width: 100%;
    overflow-wrap: anywhere;
    color: #ffffff;
    font-size: 24px;
    line-height: 1.2;
    font-weight: 800;
  }

  .wallet-summary-card p {
    max-width: 300px;
    margin: 0;
    color: #9dadbd;
    font-size: 13px;
    line-height: 1.45;
    font-weight: 600;
    text-align: right;
  }

  .wallet-money-tabs {
    display: inline-grid;
    grid-auto-flow: column;
    grid-auto-columns: minmax(86px, auto);
    align-self: flex-start;
    gap: 4px;
    padding: 4px;
    border: 1px solid rgba(132, 183, 208, 0.12);
    border-radius: 14px;
    background: rgba(6, 12, 20, 0.52);
  }

  .wallet-money-tabs button {
    min-height: 36px;
    padding: 0 16px;
    border: 0;
    border-radius: 10px;
    color: #8fa1b3;
    background: transparent;
    font-size: 13px;
    font-weight: 800;
    cursor: pointer;
    transition: color 160ms ease, background 160ms ease, box-shadow 160ms ease;
  }

  .wallet-money-tabs button:hover,
  .wallet-money-tabs button.is-active {
    color: #64f885;
    background: rgba(89, 244, 119, 0.12);
    box-shadow: inset 0 0 0 1px rgba(89, 244, 119, 0.22);
  }

  .wallet-info-grid {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 10px;
  }

  .wallet-info-tile {
    min-width: 0;
    display: grid;
    gap: 6px;
    padding: 13px 14px;
    border: 1px solid rgba(132, 183, 208, 0.13);
    border-radius: 13px;
    background: rgba(8, 17, 27, 0.38);
  }

  .wallet-info-tile span {
    color: #7f91a3;
    font-size: 11px;
    font-weight: 800;
  }

  .wallet-info-tile strong {
    min-width: 0;
    overflow: hidden;
    color: #eaf1f7;
    font-size: 13px;
    font-weight: 800;
    line-height: 1.3;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .wallet-guide {
    overflow: hidden;
    border-radius: 14px;
    border: 1px solid rgba(132, 183, 208, 0.14);
    background: rgba(8, 17, 27, 0.42);
  }

  .wallet-guide-toggle {
    width: 100%;
    min-height: 44px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 0 16px;
    border: 0;
    color: #c7d4df;
    background: transparent;
    cursor: pointer;
    font-size: 13px;
    font-weight: 800;
  }

  .wallet-guide-toggle strong {
    color: var(--crypto-green);
    font-size: 12px;
    font-weight: 800;
  }

  .wallet-guide-content {
    max-height: 178px;
    overflow: auto;
    padding: 14px 16px;
    border-top: 1px solid rgba(132, 183, 208, 0.1);
    color: #aab9c7;
    font-size: 12px;
    line-height: 1.65;
    font-weight: 600;
  }

  .wallet-guide-content::-webkit-scrollbar {
    width: 5px;
  }

  .wallet-guide-content::-webkit-scrollbar-thumb {
    border-radius: 99px;
    background: rgba(89, 244, 119, 0.52);
  }

  .wallet-guide-content p,
  .wallet-guide-content ul,
  .wallet-guide-content ol {
    margin: 0 0 8px;
  }

  .wallet-guide-content p:last-child,
  .wallet-guide-content ul:last-child,
  .wallet-guide-content ol:last-child {
    margin-bottom: 0;
  }

  .wallet-form {
    display: grid;
    gap: 14px;
    padding: 18px;
    border-radius: 16px;
    border: 1px solid rgba(132, 183, 208, 0.14);
    background: rgba(8, 17, 27, 0.42);
  }

  .wallet-field {
    display: grid;
    gap: 8px;
  }

  .wallet-field label,
  .wallet-usdt-address label {
    color: #b7c5d2;
    font-size: 13px;
    font-weight: 800;
  }

  .wallet-input-shell,
  .wallet-copyline,
  .wallet-field select {
    width: 100%;
    min-height: 50px;
    display: flex;
    align-items: center;
    gap: 12px;
    border: 1px solid rgba(132, 183, 208, 0.18);
    border-radius: 12px;
    background: #0b121d;
    color: #ffffff;
    transition: border-color 160ms ease, box-shadow 160ms ease;
  }

  .wallet-input-shell:focus-within,
  .wallet-copyline:focus-within,
  .wallet-field select:focus {
    border-color: rgba(89, 244, 119, 0.72);
    box-shadow: 0 0 0 3px rgba(89, 244, 119, 0.1);
    outline: 0;
  }

  .wallet-input-shell input {
    width: 0;
    min-width: 0;
    flex: 1 1 auto;
    height: 50px;
    border: 0;
    outline: 0;
    padding: 0 0 0 16px;
    color: #ffffff;
    background: transparent;
    font-size: 16px;
    font-weight: 700;
  }

  .wallet-input-shell input::placeholder {
    color: #758399;
  }

  .wallet-input-shell span {
    padding-right: 16px;
    color: #8fa1b3;
    font-size: 13px;
    font-weight: 800;
  }

  .wallet-field select {
    appearance: none;
    padding: 0 42px 0 16px;
    font-size: 15px;
    font-weight: 700;
    cursor: pointer;
    background:
      linear-gradient(45deg, transparent 50%, #9db2c3 50%) calc(100% - 21px) 22px / 7px 7px no-repeat,
      linear-gradient(135deg, #9db2c3 50%, transparent 50%) calc(100% - 14px) 22px / 7px 7px no-repeat,
      #0b121d;
  }

  .wallet-quick-amounts {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }

  .wallet-quick-amounts button,
  .wallet-secondary-button {
    min-width: 0;
    max-width: 100%;
    min-height: 36px;
    padding: 0 12px;
    border: 1px solid rgba(132, 183, 208, 0.16);
    border-radius: 10px;
    color: #c5d0dc;
    background: rgba(203, 215, 255, 0.05);
    font-size: 12px;
    font-weight: 800;
    white-space: nowrap;
    cursor: pointer;
    transition: color 160ms ease, border-color 160ms ease, background 160ms ease;
  }

  .wallet-quick-amounts button.is-reset {
    color: #8fa1b3;
    background: rgba(8, 17, 27, 0.7);
  }

  .wallet-quick-amounts button.is-max {
    color: #ddffe5;
    border-color: rgba(89, 244, 119, 0.3);
    background: rgba(89, 244, 119, 0.1);
  }

  .wallet-quick-amounts button:hover,
  .wallet-secondary-button:hover {
    color: #ffffff;
    border-color: rgba(89, 244, 119, 0.4);
    background: rgba(89, 244, 119, 0.1);
  }

  .wallet-inline-actions {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px;
    border-radius: 12px;
    background: rgba(203, 215, 255, 0.04);
  }

  .wallet-inline-actions p {
    min-width: 0;
    max-width: 100%;
    margin: 0;
    color: #8796a8;
    font-size: 12px;
    line-height: 1.45;
    font-weight: 600;
    overflow-wrap: anywhere;
  }

  .wallet-usdt-lite,
  .wallet-usdt-rate {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 12px 14px;
    border: 1px solid rgba(132, 183, 208, 0.13);
    border-radius: 12px;
    background: rgba(6, 12, 20, 0.42);
  }

  .wallet-usdt-lite div {
    min-width: 0;
    display: grid;
    gap: 5px;
  }

  .wallet-usdt-lite span,
  .wallet-usdt-rate span {
    color: #8fa1b3;
    font-size: 12px;
    font-weight: 800;
  }

  .wallet-usdt-lite strong,
  .wallet-usdt-rate strong {
    min-width: 0;
    overflow: hidden;
    color: #ffffff;
    font-size: 13px;
    font-weight: 800;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .wallet-usdt-lite button,
  .wallet-copyline button {
    min-height: 38px;
    padding: 0 13px;
    border: 1px solid rgba(89, 244, 119, 0.26);
    border-radius: 10px;
    color: #64f885;
    background: rgba(89, 244, 119, 0.09);
    font-size: 12px;
    font-weight: 800;
    cursor: pointer;
    transition: color 160ms ease, border-color 160ms ease, background 160ms ease;
  }

  .wallet-usdt-lite button:hover:not(:disabled),
  .wallet-copyline button:hover:not(:disabled) {
    color: #07110b;
    border-color: rgba(89, 244, 119, 0.7);
    background: #59f477;
  }

  .wallet-usdt-lite button:disabled,
  .wallet-copyline button:disabled {
    cursor: not-allowed;
    opacity: 0.45;
  }

  .wallet-usdt-panel {
    display: grid;
    gap: 14px;
    padding: 16px;
    border-radius: 15px;
    border: 1px solid rgba(132, 183, 208, 0.15);
    background:
      radial-gradient(circle at 96% 0%, rgba(89, 244, 119, 0.14), transparent 38%),
      rgba(6, 12, 20, 0.44);
  }

  .wallet-usdt-panel-head {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 14px;
  }

  .wallet-usdt-panel-head div {
    display: grid;
    gap: 4px;
  }

  .wallet-usdt-panel-head span {
    color: #8fa1b3;
    font-size: 12px;
    font-weight: 800;
  }

  .wallet-usdt-panel-head strong {
    color: #ffffff;
    font-size: 17px;
    line-height: 1.25;
    font-weight: 900;
  }

  .wallet-usdt-panel-head em {
    color: #64f885;
    font-size: 12px;
    font-style: normal;
    font-weight: 800;
    white-space: nowrap;
  }

  .wallet-usdt-address {
    display: grid;
    gap: 8px;
  }

  .wallet-copyline {
    display: grid;
    gap: 0;
    grid-template-columns: minmax(0, 1fr) auto;
    overflow: hidden;
  }

  .wallet-copyline input {
    width: 100%;
    min-width: 0;
    height: 50px;
    border: 0;
    outline: 0;
    padding: 0 16px;
    color: #ffffff;
    background: transparent;
    font-size: 16px;
    font-weight: 700;
  }

  .wallet-copyline button {
    min-height: 50px;
    border-width: 0 0 0 1px;
    border-radius: 0;
  }

  .wallet-usdt-qr {
    width: 128px;
    height: 128px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    justify-self: center;
    padding: 8px;
    border-radius: 14px;
    background: #ffffff;
  }

  .wallet-usdt-qr svg {
    width: 100%;
    height: 100%;
    display: block;
  }

  .wallet-usdt-warning {
    display: grid;
    gap: 6px;
    padding: 12px;
    border-radius: 12px;
    color: #9dadbd;
    background: rgba(203, 215, 255, 0.04);
    font-size: 12px;
    line-height: 1.4;
    font-weight: 700;
    overflow-wrap: anywhere;
  }

  .wallet-usdt-empty {
    padding: 20px 14px;
    border-radius: 12px;
    color: #8fa1b3;
    background: rgba(203, 215, 255, 0.04);
    font-size: 13px;
    font-weight: 700;
    text-align: center;
  }

  .wallet-usdt-empty.is-error {
    display: grid;
    justify-items: center;
    gap: 8px;
    color: #aab8c7;
    border: 1px solid rgba(255, 123, 123, 0.18);
    background: rgba(255, 123, 123, 0.055);
  }

  .wallet-usdt-empty.is-error strong {
    color: #ffffff;
    font-size: 14px;
  }

  .wallet-usdt-empty.is-error span {
    max-width: 420px;
    line-height: 1.5;
  }

  .wallet-usdt-empty.is-error .wallet-secondary-button {
    min-height: 38px;
    margin-top: 4px;
    padding: 0 16px;
  }

  .wallet-submit-button {
    min-height: 52px;
    border: 0;
    border-radius: 13px;
    color: #06110b;
    background: linear-gradient(180deg, #59f477, #25d963);
    box-shadow: 0 14px 30px rgba(37, 217, 99, 0.22), inset 0 1px 0 rgba(255, 255, 255, 0.28);
    font-size: 17px;
    font-weight: 900;
    cursor: pointer;
    transition: transform 160ms ease, filter 160ms ease;
  }

  .wallet-submit-button:hover {
    filter: brightness(1.05);
    transform: translateY(-1px);
  }

  .wallet-submit-button:disabled,
  .wallet-secondary-button:disabled {
    cursor: not-allowed;
    opacity: 0.65;
    transform: none;
  }

  .wallet-alert-backdrop {
    position: fixed;
    inset: 0;
    z-index: 7000;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px;
    background: rgba(5, 8, 14, 0.7);
    backdrop-filter: blur(5px);
    animation: walletAlertFade 0.16s ease both;
  }

  .wallet-alert-panel {
    width: min(100%, 360px);
    display: grid;
    justify-items: center;
    gap: 12px;
    padding: 26px 24px 24px;
    text-align: center;
    border: 1px solid rgba(132, 183, 208, 0.18);
    border-radius: 16px;
    background:
      radial-gradient(circle at 50% 0%, rgba(89, 244, 119, 0.12), transparent 42%),
      #101b26;
    box-shadow:
      0 24px 70px rgba(0, 0, 0, 0.48),
      inset 0 1px 0 rgba(255, 255, 255, 0.06);
    animation: walletAlertPop 0.18s ease both;
  }

  .wallet-alert-panel.is-error {
    border-color: rgba(255, 114, 114, 0.28);
    background:
      radial-gradient(circle at 50% 0%, rgba(255, 114, 114, 0.12), transparent 42%),
      #101b26;
  }

  .wallet-alert-panel.is-confirm {
    border-color: rgba(89, 244, 119, 0.32);
  }

  .wallet-alert-icon {
    width: 48px;
    height: 48px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 999px;
    color: #06110b;
    background: linear-gradient(180deg, #59f477, #25d963);
    box-shadow: 0 10px 28px rgba(37, 217, 99, 0.28);
  }

  .wallet-alert-panel.is-error .wallet-alert-icon {
    color: #260909;
    background: linear-gradient(180deg, #ff9b9b, #ff6868);
    box-shadow: 0 10px 28px rgba(255, 104, 104, 0.22);
  }

  .wallet-alert-panel.is-confirm .wallet-alert-icon {
    color: #06110b;
    background: linear-gradient(180deg, #8df5a0, #35dc68);
    box-shadow: 0 10px 28px rgba(37, 217, 99, 0.22);
  }

  .wallet-alert-icon svg {
    width: 26px;
    height: 26px;
    display: block;
    fill: none;
    stroke: currentColor;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-width: 2.8;
  }

  .wallet-alert-panel strong {
    color: #ffffff;
    font-size: 19px;
    line-height: 1.25;
    font-weight: 900;
  }

  .wallet-alert-panel p {
    margin: 0;
    color: #b9c6d7;
    font-size: 14px;
    line-height: 1.55;
    font-weight: 700;
    word-break: keep-all;
  }

  .wallet-alert-panel button {
    min-width: 128px;
    height: 42px;
    margin-top: 4px;
    border: 0;
    border-radius: 10px;
    color: #06110b;
    background: linear-gradient(180deg, #59f477, #25d963);
    font-size: 14px;
    font-weight: 900;
    cursor: pointer;
    transition: transform 160ms ease, filter 160ms ease;
  }

  .wallet-alert-panel.is-error button {
    color: #ffffff;
    background: rgba(203, 215, 255, 0.08);
    box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.08);
  }

  .wallet-alert-actions {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px;
  }

  .wallet-alert-actions button {
    min-width: 0;
  }

  .wallet-alert-actions button.is-cancel {
    color: #c5d0dc;
    background: rgba(203, 215, 255, 0.08);
    box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.08);
  }

  .wallet-alert-panel button:disabled {
    cursor: not-allowed;
    opacity: 0.58;
    transform: none;
  }

  .wallet-alert-panel button:hover {
    filter: brightness(1.05);
    transform: translateY(-1px);
  }

  .wallet-history {
    display: flex;
    flex-direction: column;
    overflow: hidden;
    border-radius: 16px;
    border: 1px solid rgba(132, 183, 208, 0.14);
    background: rgba(8, 17, 27, 0.38);
    transition: border-color 180ms ease, background 180ms ease;
  }

  .wallet-history-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 16px;
    border-bottom: 1px solid rgba(132, 183, 208, 0.1);
  }

  .wallet-history-header h4 {
    margin: 0;
    color: #ffffff;
    font-size: 15px;
    font-weight: 800;
  }

  .wallet-history-header span {
    color: #7f91a3;
    font-size: 12px;
    font-weight: 700;
  }

  .wallet-history-header-actions {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .wallet-history-header-actions button,
  .wallet-history-delete-cell button {
    min-height: 28px;
    padding: 0 10px;
    border: 1px solid rgba(255, 114, 114, 0.2);
    border-radius: 8px;
    color: #ff9b9b;
    background: rgba(255, 104, 104, 0.07);
    font-size: 11px;
    font-weight: 800;
    cursor: pointer;
  }

  .wallet-history-header-actions button:hover:not(:disabled),
  .wallet-history-delete-cell button:hover:not(:disabled) {
    border-color: rgba(255, 114, 114, 0.4);
    background: rgba(255, 104, 104, 0.13);
  }

  .wallet-history-header-actions button:disabled,
  .wallet-history-delete-cell button:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }

  .wallet-history-table {
    --wallet-history-row-height: 42px;
    display: grid;
    min-height: calc(38px + (var(--wallet-history-row-height) * 4));
    align-content: start;
    background:
      linear-gradient(180deg, transparent 0%, rgba(6, 12, 20, 0.18) 100%);
  }

  .wallet-history-row {
    display: grid;
    grid-template-columns: 0.9fr 1fr 1fr 0.7fr;
    gap: 10px;
    align-items: center;
    min-height: var(--wallet-history-row-height);
    padding: 0 16px;
    color: #b8c4d1;
    font-size: 12px;
    font-weight: 700;
  }

  .wallet-history-row.has-delete-action {
    grid-template-columns: 0.9fr 1fr 1fr 0.7fr 0.55fr;
  }

  .wallet-history-row:nth-child(odd):not(.is-head):not(.is-skeleton) {
    background: rgba(203, 215, 255, 0.035);
  }

  .wallet-history-row.is-head {
    min-height: 38px;
    color: #7f91a3;
    background: rgba(6, 12, 20, 0.48);
    font-size: 11px;
    font-weight: 800;
  }

  .wallet-history-row span:nth-child(3),
  .wallet-history-row span:nth-child(4),
  .wallet-history-row span:nth-child(5) {
    text-align: right;
  }

  .wallet-history-delete-cell {
    display: flex;
    justify-content: flex-end;
  }

  .wallet-sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
  }

  .wallet-history-row > span {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .wallet-crypto-history-row {
    grid-template-columns:
      minmax(76px, 0.85fr)
      minmax(74px, 0.75fr)
      minmax(74px, 0.75fr)
      minmax(78px, 0.85fr)
      minmax(42px, 0.5fr)
      minmax(92px, 1fr)
      minmax(66px, 0.7fr);
    gap: 8px;
  }

  .wallet-crypto-history-row span:nth-child(n + 2):not(:nth-child(6)) {
    text-align: right;
  }

  .wallet-crypto-tx {
    min-width: 0;
    overflow: hidden;
    color: #8fa1b3;
    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
    font-size: 11px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .wallet-history-row .is-complete {
    color: #59f477;
  }

  .wallet-history-row .is-pending {
    color: #ffc35a;
  }

  .wallet-history-row .is-cancelled {
    color: #ff7b7b;
  }

  .wallet-history-pager {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    padding: 12px 16px 14px;
    border-top: 1px solid rgba(132, 183, 208, 0.1);
  }

  .wallet-history-pager.is-hidden {
    visibility: hidden;
    pointer-events: none;
  }

  .wallet-history-pager button {
    width: 34px;
    height: 34px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border: 1px solid rgba(132, 183, 208, 0.14);
    border-radius: 10px;
    color: #dce6ef;
    background: rgba(203, 215, 255, 0.06);
    font-size: 22px;
    font-weight: 800;
    cursor: pointer;
    transition: color 160ms ease, border-color 160ms ease, background 160ms ease;
  }

  .wallet-history-pager button:hover:not(:disabled) {
    color: #ffffff;
    border-color: rgba(89, 244, 119, 0.42);
    background: rgba(89, 244, 119, 0.1);
  }

  .wallet-history-pager button:disabled {
    cursor: not-allowed;
    opacity: 0.45;
  }

  .wallet-history-pager span {
    min-width: 52px;
    color: #8fa1b3;
    font-size: 12px;
    font-weight: 800;
    text-align: center;
  }

  .wallet-history-row.is-skeleton i {
    height: 12px;
    border-radius: 99px;
    background: linear-gradient(90deg, rgba(203, 215, 255, 0.05), rgba(203, 215, 255, 0.13), rgba(203, 215, 255, 0.05));
    background-size: 220% 100%;
    animation: walletShimmer 1.3s ease infinite;
  }

  .wallet-empty-history {
    min-height: calc(var(--wallet-history-row-height) * 4);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 16px;
    color: #8796a8;
    font-size: 13px;
    font-weight: 700;
    text-align: center;
  }

  @keyframes walletShimmer {
    0% {
      background-position: 120% 0;
    }
    100% {
      background-position: -120% 0;
    }
  }

  @keyframes cashierHomeEnter {
    from {
      opacity: 0;
      transform: translateY(12px) scale(0.99);
    }
    to {
      opacity: 1;
      transform: translateY(0) scale(1);
    }
  }

  @keyframes cashierDetailEnter {
    from {
      opacity: 0;
      transform: translateX(14px);
    }
    to {
      opacity: 1;
      transform: translateX(0);
    }
  }

  @keyframes walletAlertFade {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  @keyframes walletAlertPop {
    from {
      opacity: 0;
      transform: translateY(8px) scale(0.98);
    }
    to {
      opacity: 1;
      transform: translateY(0) scale(1);
    }
  }

  @media (prefers-reduced-motion: reduce) {
    .cashier-modal-body.is-home .cashier-home,
    .cashier-modal-body.is-detail .cashier-detail {
      animation: none;
    }
  }

  @media (max-width: 720px) {
    .cashier-modal-header {
      padding: 20px;
    }

    .cashier-modal-title {
      font-size: 24px;
    }

    .cashier-modal-body {
      padding: 18px;
    }

    .cashier-action-grid {
      grid-template-columns: 1fr;
    }

    .wallet-summary-card,
    .wallet-inline-actions {
      align-items: flex-start;
      flex-direction: column;
    }

    .wallet-money-tabs {
      width: 100%;
      grid-auto-columns: minmax(0, 1fr);
    }

    .wallet-info-grid {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    .wallet-summary-card p {
      max-width: none;
      text-align: left;
    }

    .wallet-usdt-lite,
    .wallet-usdt-rate,
    .wallet-usdt-panel-head {
      align-items: flex-start;
      flex-direction: column;
    }

    .wallet-history-row {
      grid-template-columns: 0.8fr 1fr 1fr 0.6fr;
      gap: 8px;
      padding: 0 12px;
      font-size: 11px;
    }

    .wallet-history-table.is-crypto {
      min-height: calc(var(--wallet-history-row-height) * 4);
    }

    .wallet-crypto-history-row.is-head {
      display: none;
    }

    .wallet-crypto-history-row:not(.is-head) {
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 7px 14px;
      min-height: 0;
      padding: 12px;
      border-bottom: 1px solid rgba(132, 183, 208, 0.1);
    }

    .wallet-crypto-history-row:not(.is-head) span {
      min-width: 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 8px;
      text-align: right;
    }

    .wallet-crypto-history-row:not(.is-head) span::before {
      flex: none;
      color: #73869a;
      content: attr(data-label);
      font-size: 10px;
      font-weight: 800;
    }

    .wallet-crypto-history-row:not(.is-head) .wallet-crypto-tx {
      grid-column: 1 / -1;
    }

    .wallet-crypto-history-row.is-skeleton i {
      min-width: 0;
    }
  }

  @media (max-width: 520px) {
    .wallet-quick-amounts {
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    .wallet-quick-amounts button {
      width: 100%;
      padding: 0 8px;
    }

    .wallet-info-grid {
      grid-template-columns: 1fr;
    }

    .wallet-copyline {
      grid-template-columns: 1fr;
    }

    .wallet-copyline button {
      border-width: 1px 0 0;
    }

    .wallet-history-row:not(.wallet-crypto-history-row).is-head {
      display: none;
    }

    .wallet-history-row:not(.wallet-crypto-history-row):not(.is-head) {
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 8px 14px;
      min-height: 0;
      padding: 12px;
      border-bottom: 1px solid rgba(132, 183, 208, 0.1);
    }

    .wallet-history-row:not(.wallet-crypto-history-row):not(.is-head) > span {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 8px;
      text-align: right;
    }

    .wallet-history-row:not(.wallet-crypto-history-row):not(.is-head) > span::before {
      flex: none;
      color: #73869a;
      content: attr(data-label);
      font-size: 10px;
      font-weight: 800;
    }
  }

  @media (max-width: 420px) {
    .cashier-modal-header {
      padding: 16px;
    }

    .cashier-modal-body {
      padding: 12px;
    }

    .wallet-form,
    .wallet-summary-card {
      padding: 14px;
    }

    .wallet-money-tabs button {
      padding: 0 8px;
      font-size: 12px;
    }

    .wallet-money-tabs {
      grid-auto-flow: row;
      grid-auto-columns: auto;
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    .wallet-guide-toggle {
      padding: 0 12px;
    }

    .wallet-history-header,
    .wallet-history-pager {
      padding-right: 12px;
      padding-left: 12px;
    }

    .wallet-crypto-history-row:not(.is-head) {
      grid-template-columns: 1fr;
    }

    .wallet-usdt-panel-head em {
      max-width: 100%;
      overflow-wrap: anywhere;
      white-space: normal;
    }
  }

  @media (max-width: 320px) {
    .wallet-quick-amounts,
    .wallet-history-row:not(.wallet-crypto-history-row):not(.is-head) {
      grid-template-columns: 1fr;
    }
  }
`;
export const StyledModalContent = styled.div`
  .title {
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    margin-bottom: 24px;
    color: rgb(255, 255, 255);
    text-transform: uppercase;
    word-break: break-word;
    gap: 12px;
    font-size: 22px;
    font-weight: 800;
  }

  .options {
    display: grid;
    -webkit-box-align: stretch;
    align-items: stretch;
    grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
    gap: 12px;
  }

  .option {
    border-radius: 8px;
    background: rgba(203, 215, 255, 0.03);
    display: inline-block;
    padding: 20px;
    cursor: pointer;

    .icons-container {
      display: flex;
      -webkit-box-pack: center;
      justify-content: center;
      -webkit-box-align: center;
      align-items: center;
      margin-bottom: 14px;

      .multiple-icons {
        display: grid;
        -webkit-box-align: center;
        align-items: center;
        -webkit-box-pack: center;
        justify-content: center;
        gap: 6px;
        grid-template-columns: 1fr 1fr 1fr;
      }

      .icon-img {
        display: inline-block;
        border-radius: 999px;
        width: 32px;
        min-width: 32px;
        height: auto;
      }

      .nft-img {
        display: block;
        height: 32px;
      }

      .paying-methods {
        display: grid;
        -webkit-box-align: center;
        place-items: center;
        gap: 16px 12px;
        grid-template-columns: 1fr 1fr;
      }
    }

    .option-title {
      display: flex;
      flex-direction: column;
      -webkit-box-pack: center;
      justify-content: center;
      -webkit-box-align: center;
      align-items: center;
      /* margin-bottom: 14px; */
      color: #fff;
    }

    .option-subtitle {
      margin-top: 4px;
      color: rgb(177, 182, 198);
      text-align: center;
      font-size: 12px;
      font-weight: 500;
      font-style: normal;
    }
  }
`;

export const StyledCouponsContent = styled.div`
  display: flex;
  flex-direction: column;
  -webkit-box-align: center;
  align-items: center;
  padding-bottom: 24px;

  img {
    display: inline-block;
    flex: 0 0 auto;
    line-height: 0;
    width: 153px;
    min-width: 153px;
    height: auto;
  }

  .title {
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    margin-bottom: 24px;
    color: rgb(255, 255, 255);
    text-transform: uppercase;
    word-break: break-word;
    gap: 12px;
    font-size: 22px;
    font-weight: 800;
    font-style: normal;
  }

  .input-container {
    width: 100%;
    max-width: 220px;
    margin-bottom: 24px;

    input {
      display: flex;
      -webkit-box-align: center;
      align-items: center;
      height: 50px;
      min-height: 50px;
      width: 100%;
      padding: 0px 5px 0px 15px;
      border-radius: 6px;
      border: 1px solid transparent;
      background: rgba(15, 17, 26, 0.55);
      transition: background 0.1s ease 0s;

      width: 100%;
      height: 100%;
      color: rgb(255, 255, 255);
      font-weight: 700;
      font-style: normal;
      font-size: 15px;
      overflow: visible;
      background: rgba(15, 17, 26, 0.55);

      &:focus-within {
        border: 1px solid var(--crypto-green);
        box-shadow: var(--crypto-green-glow) 0px 0px 4px;
      }
    }
  }

  .info-text {
    font-size: 14px;
    font-weight: 500;
    font-style: normal;

    a {
      cursor: pointer;
      color: rgb(255, 176, 24);

      &:hover {
        text-decoration: underline;
      }
    }
  }

  .claim-button {
    display: inline-flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: center;
    justify-content: center;
    white-space: nowrap;
    transition: all 0.1s ease 0s;
    appearance: none;
    border: none;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    cursor: pointer;
    user-select: none;
    height: 40px;
    padding: 0px 20px;
    border-radius: 8px;
    font-weight: 800;
    font-style: normal;
    font-size: 14px;
    color: rgb(20, 23, 34);
    background: rgb(134, 244, 84);
    box-shadow: rgba(118, 255, 25, 0.4) 0px 0px 10px,
      rgba(255, 255, 255, 0.2) 0px 1px 0px inset,
      rgba(0, 0, 0, 0.15) 0px -3px 0px inset,
      rgb(59, 198, 14) 0px 0px 12px inset;

    &:hover {
      filter: brightness(110%);
    }
  }
`;
